import { defineStore } from 'pinia';
import { createPopulateString, parseCollectionData } from '~/utils/strapiComponents/addStrapiData';
import { processBannerRules } from '~/utils/strapiComponents/filters';
import { strapi } from '../transport/strapi';
import type { IRacesBannerData, IRacesBannerStrapiResponse } from '~/types/races';

export const useStoreRacesBanner = defineStore('racesBanner', {
  state: () => ({
    banners: [] as IRacesBannerData[],
    requestPromise: null as Promise<IRacesBannerStrapiResponse> | null,
  }),

  getters: {
    personalList(state): IRacesBannerData[] {
      return state.banners.filter((banner): boolean =>
        banner.bannerRules?.length ? processBannerRules(banner.bannerRules) : true
      );
    },
  },

  actions: {
    async loadRacesBanners() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'bannerCardFront',
          'bannerCardBack',
          'bannerRules',
        ]);

        this.requestPromise = strapi()
          .get('races-banners', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        const parsedData = parseCollectionData(response.data);
        const filteredState = this.banners.filter(
          (item) => !parsedData.find(({ id }) => id && id === item.id)
        );

        this.banners = [...filteredState, ...parsedData];

        return true;
      } else {
        return false;
      }
    },
  },
});
